import { render, staticRenderFns } from "./form-table.vue?vue&type=template&id=714130fa&scoped=true&"
import script from "./form-table.vue?vue&type=script&lang=js&"
export * from "./form-table.vue?vue&type=script&lang=js&"
import style0 from "./form-table.vue?vue&type=style&index=0&id=714130fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714130fa",
  null
  
)

component.options.__file = "form-table.vue"
export default component.exports